<template>
    <main class="main clear">
        <router-view />
        <Notifications />
    </main>
</template>
<script>
import Notifications from "@/components/Modals/Notifications/index";
export default {
    components: {
        Notifications
    },
}
</script>